import ViewSubmitedResult from './result';

const ViewSubmittedResultPage = () => (
	<div>
		<ViewSubmitedResult />
	</div>
);

export default ViewSubmittedResultPage;
